import React, { useEffect, useState } from 'react';
import { Plus, Copy, Trash2, KeyRound, Check, Terminal, ShieldCheck, FileBarChart } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import { fecha, Empty } from './ui';

const EJEMPLO = `curl -X POST https://admin.udream.app/api/ingest/reportes \\
  -H "Authorization: Bearer TU_LLAVE" \\
  -H "Content-Type: application/json" \\
  -d '{
    "cliente": "Grupo Velsky",
    "servicio": "Paid Media",
    "periodo": "2026-09",
    "conclusion": "Bajamos el costo por consulta un 18% respecto de agosto.",
    "plataformas": [
      { "nombre": "Google Ads", "inversion": 350000, "clics": 1240, "resultados": 45 },
      { "nombre": "Meta Ads", "inversion": 200000, "impresiones": 82000, "resultados": 30 }
    ],
    "publicar": "portal"
  }'`;

const ALCANCES = {
  admin: { label: 'Administración', color: '#f59e0b', icono: ShieldCheck,
    detalle: 'Consulta y carga clientes, cobros, proyectos, minutas y propuestas.' },
  reportes: { label: 'Solo reportes', color: '#0ea5e9', icono: FileBarChart,
    detalle: 'Únicamente sube informes de campañas al portal.' },
};

export function LlavesApi() {
  const [tokens, setTokens] = useState(null);
  const [nuevo, setNuevo] = useState(null);
  const [copiado, setCopiado] = useState(false);
  const [alta, setAlta] = useState(null);

  const cargar = () => api.get('/agency/reportes-campana/tokens/lista').then(r => setTokens(r.data)).catch(() => toast.error('No se pudo cargar'));
  useEffect(() => { cargar(); }, []);

  const crear = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/agency/reportes-campana/tokens', alta);
      setNuevo(data.token); setCopiado(false); setAlta(null); cargar();
    } catch { toast.error('No se pudo crear'); }
  };
  const cambiarAlcance = async (t) => {
    const admin = t.alcance !== 'admin';
    if (!window.confirm(admin
      ? `"${t.nombre}" va a poder administrar: cargar clientes, cobros, proyectos y minutas.`
      : `"${t.nombre}" va a quedar limitada a subir reportes.`)) return;
    try { await api.put('/agency/reportes-campana/tokens/' + t.id, { alcance: admin ? 'admin' : 'reportes' }); cargar(); }
    catch { toast.error('No se pudo cambiar'); }
  };
  const borrar = async (t) => {
    if (!window.confirm(`¿Dar de baja "${t.nombre}"?\n\nLo que la use deja de tener acceso ahora mismo. No se puede recuperar.`)) return;
    try { await api.delete('/agency/reportes-campana/tokens/' + t.id); toast.success('Llave dada de baja'); cargar(); }
    catch { toast.error('Error'); }
  };
  const copiar = (txt) => navigator.clipboard.writeText(txt)
    .then(() => { setCopiado(true); toast.success('Copiada'); }).catch(() => toast.error('No se pudo copiar'));

  if (!tokens) return <div className="card" style={{ color: 'var(--text-muted)' }}>Cargando...</div>;

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}><KeyRound size={18} /> Llaves de API</h3>
        <button className="btn btn-secondary btn-sm" onClick={() => setAlta({ nombre: '', alcance: 'admin' })}><Plus size={14} /> Nueva llave</button>
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4, marginBottom: 16 }}>
        Con una llave, el agente de tu Mac trabaja sobre la plataforma sin usar tu usuario.
        Se muestra una sola vez: guardala apenas la crees.
      </div>

      {nuevo && (
        <div style={{ background: 'rgba(34,197,94,0.10)', border: '1px solid rgba(34,197,94,0.35)', borderRadius: 12, padding: 14, marginBottom: 18 }}>
          <div style={{ fontSize: 12, color: '#22c55e', fontWeight: 700, marginBottom: 8 }}>
            Copiala ahora · no se vuelve a mostrar
          </div>
          <code style={{ display: 'block', fontSize: 12.5, wordBreak: 'break-all', background: 'var(--bg-secondary)',
            padding: '10px 12px', borderRadius: 8, marginBottom: 10 }}>{nuevo}</code>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="btn btn-primary btn-sm" onClick={() => copiar(nuevo)}>
              {copiado ? <><Check size={14} /> Copiada</> : <><Copy size={14} /> Copiar</>}
            </button>
            <button className="btn btn-ghost btn-sm" onClick={() => setNuevo(null)}>Ya la guardé</button>
          </div>
        </div>
      )}

      {tokens.length ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {tokens.map(t => {
            const a = ALCANCES[t.alcance] || ALCANCES.reportes;
            const Icono = a.icono;
            return (
              <div key={t.id} style={{ border: '1px solid var(--border)', borderRadius: 12, padding: '12px 14px',
                display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, flexShrink: 0, display: 'flex',
                  alignItems: 'center', justifyContent: 'center', background: a.color + '22', color: a.color }}>
                  <Icono size={17} />
                </div>
                <div style={{ minWidth: 0, flex: '1 1 200px' }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{t.nombre}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 2 }}>
                    <code>{t.prefijo}…</code> · {t.ultimo_uso ? `usada el ${fecha(t.ultimo_uso)}` : 'sin usar todavía'}
                  </div>
                </div>
                <div style={{ minWidth: 0, flex: '1 1 220px' }}>
                  <span onClick={() => cambiarAlcance(t)} title="Tocá para cambiar el alcance"
                    style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, color: a.color }}>{a.label}</span>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{a.detalle}</div>
                </div>
                <button className="btn btn-ghost btn-sm" onClick={() => borrar(t)} title="Dar de baja"><Trash2 size={15} /></button>
              </div>
            );
          })}
        </div>
      ) : <Empty>Todavía no creaste ninguna llave</Empty>}

      {alta && (
        <div className="modal-overlay" onClick={() => setAlta(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 440 }}>
            <h2>Nueva llave</h2>
            <form onSubmit={crear}>
              <div className="form-group"><label>Nombre</label>
                <input value={alta.nombre} onChange={e => setAlta({ ...alta, nombre: e.target.value })}
                  placeholder="Agente de Udream" required autoFocus /></div>
              <div className="form-group"><label>Qué va a poder hacer</label>
                {Object.entries(ALCANCES).map(([k, a]) => (
                  <label key={k} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 12px',
                    border: '1px solid ' + (alta.alcance === k ? 'var(--accent)' : 'var(--border)'),
                    borderRadius: 10, marginBottom: 8, cursor: 'pointer' }}>
                    <input type="radio" name="alcance" checked={alta.alcance === k} onChange={() => setAlta({ ...alta, alcance: k })}
                      style={{ width: 16, height: 16, marginTop: 2 }} />
                    <span>
                      <span style={{ fontWeight: 700, fontSize: 13.5, color: a.color }}>{a.label}</span>
                      <span style={{ display: 'block', fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{a.detalle}</span>
                    </span>
                  </label>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setAlta(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear llave</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

/* Cómo la usa el agente */
export function ApiDocs() {
  const paso = { display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 12 };
  const numero = { width: 22, height: 22, borderRadius: '50%', background: 'var(--accent-glow)', color: 'var(--accent)',
    fontSize: 11, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 };
  const pre = { background: 'var(--bg-secondary)', padding: 14, borderRadius: 10, fontSize: 11.5, overflowX: 'auto',
    whiteSpace: 'pre', color: 'var(--text-secondary)', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', lineHeight: 1.6 };

  return (
    <div className="card">
      <h3 style={{ fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Terminal size={18} /> Cómo la usa el agente
      </h3>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4, marginBottom: 16 }}>
        Todas las llamadas llevan la llave en el encabezado. Si el reporte de ese mes ya existe, se actualiza
        en vez de duplicarse.
      </div>

      <div style={paso}>
        <span style={numero}>1</span>
        <div style={{ fontSize: 13, minWidth: 0 }}>
          <code>GET /api/ingest/clientes</code>
          <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>Los clientes con sus servicios y sus ids.</div>
        </div>
      </div>
      <div style={paso}>
        <span style={numero}>2</span>
        <div style={{ fontSize: 13, minWidth: 0 }}>
          <code>GET /api/ingest/reportes?cliente=Grupo Velsky</code>
          <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>Los meses anteriores, para comparar.</div>
        </div>
      </div>
      <div style={paso}>
        <span style={numero}>3</span>
        <div style={{ fontSize: 13, minWidth: 0 }}>
          <code>POST /api/ingest/reportes</code>
          <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>Carga o actualiza el mes.</div>
        </div>
      </div>

      <pre style={pre}>{EJEMPLO}</pre>

      <div style={{ fontSize: 13, margin: '14px 0 8px' }}>Y para adjuntar el informe, con el id que devuelve:</div>
      <pre style={pre}>{`curl -X POST https://admin.udream.app/api/ingest/reportes/ID/documento \\
  -H "Authorization: Bearer TU_LLAVE" \\
  -F "documento=@reporte-septiembre.pdf"`}</pre>

      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 14, lineHeight: 1.7 }}>
        <b>publicar</b> acepta <code>no</code>, <code>portal</code>, <code>email</code> o <code>ambos</code>.
        Con <code>no</code> queda como borrador y lo publicás vos desde la ficha del servicio.
        <br />
        Las llaves de <b>administración</b> además usan <code>/api/agente</code> para consultar y cargar
        clientes, cobros, proyectos y minutas.
      </div>
    </div>
  );
}
